import { Config } from 'core/common/contexts';
import { normalizeError } from 'core/common/errors';
import { HttpClient } from 'core/common/services';
import { Logger } from 'core/common/services/logger/interfaces';
import { CardBrand, CardType } from 'core/payments/entities';
import { LtvPredictParams } from '../../entities';
import { LtvPredictService } from '../../interfaces';
import { EltvDto } from './dto';

export class HttpLtvPredictService implements LtvPredictService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly logger: Logger,
    private readonly config: Config,
  ) {}

  async getLTVPredict({ amountMinorUnits, currency, cardType, cardBrand }: LtvPredictParams) {
    try {
      const { data } = await this.httpClient.get<EltvDto>(
        '/marketing-event-service/marketing/eltv',
        {
          params: {
            amount: amountMinorUnits,
            currency,
            ...(cardType !== CardType.UNKNOWN ? { card_type: cardType } : {}),
            ...(cardBrand !== CardBrand.UNKNOWN ? { card_brand: cardBrand } : {}),
          },
        },
      );

      return data.eltv;
    } catch (error) {
      const err = normalizeError(error);
      this.logger.error(err);

      return this.config.marketing.fallbackEltv;
    }
  }
}
